import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigState } from '@app/core/store/config/config.state';
import { ITradeInSystemItem } from '@app/shared/interfaces/tradein-system-item.interface';
import { TradeInSytemCollection } from '@app/shared/models/tradein-system.collection';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./_menu.component.sass'],
})
export class MenuComponent {
  @Input() itens: [];
  @Input() drawer: MatDrawer;
  @Input() toggle: boolean;
  @Select(ConfigState.activeRoute) activeRoute$: Observable<string>;
  activeRouteLink: string[];
  activeSystemItem: ITradeInSystemItem;
  public pathName: string;

  get initialPath(): string {
    const [_, ...rest] = this.pathName.split('/');
    return rest.join('/');
  }

  constructor(location: Location, _router: Router, private _store: Store) {
    this.activeRoute$.subscribe((active) => {
      this.activeSystemItem = TradeInSytemCollection.find((item) => item.role === active);
      this.activeRouteLink = [`/${active}/`];
    });
    _router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._setPathName(location.path());
      }
    });
  }

  toggleSide() {
    if (this.toggle) {
      this.drawer.toggle();
    }
  }

  checkIsActive(route) {
    const pathParts = this.initialPath.split('/');
    if (pathParts[0] === 'triagem' && route.split('/')[0] === 'triagem') {
      return true;
    }

    if (pathParts[0] === 'pedidos' && route.split('/')[0] === 'pedidos') {
      return true;
    }

    if (pathParts[0] === 'precificacao' && route.split('/')[0] === 'precificacao') {
      return true;
    }

    return route === this.initialPath;
  }

  trackByFn(index: number): number {
    return index;
  }

  private _setPathName(path = 'home'): void {
    this.pathName = path;
  }
}
